import { CompIconPickerCore } from '../core/icon-picker/comp'

export const CompIconPicker = CompIconPickerCore
